import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';

import { connect } from "react-redux";
import * as playlistActions from "../../actions/playlist";
import {withRouter} from 'react-router';

import { Modal, ModalBody, ModalFooter, Button} from 'reactstrap';

import PropTypes from 'prop-types';

import Loader from 'react-loader-spinner';
import {IMGIX_PATH, PUB_PLAYER_PATH, UNPUB_PLAYER_PATH} from "../../constants";
import UploadFile from '../includes/UploadFile';
import NewPlaylist from "./NewPlaylist";
import * as vignetsActions from "../../actions/vignets";
import VignetItem from "./VignetItem";
import VigItem from "./VigItem";
import FilterBar from "../common/FilterBar";
import AuthService from "../../lib/AuthService";
import {Collapse} from 'react-bootstrap'

class PlaylistDetailContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            backtoPlaylist : false,
            showDuplicatedPlaylist : false,
            image_path: null,
            detUrl : false,
            items : [],
            showVignetList : false,
            showPreview : false,
            showshareModal : false,
            showPlOptions : false

        };

        this.Auth = new AuthService();
        this.playlistDetail = this.playlistDetail.bind(this);
        //this.handleDrag = this.handleDrag.bind(this);
        this.editPlaylist = this.editPlaylist.bind(this);
        this.csToggle = this.csToggle.bind(this);
        this.deletePlaylist = this.deletePlaylist.bind(this);
        this.createDuplicatePlaylist = this.createDuplicatePlaylist.bind(this);
        this.mToggle = this.mToggle.bind(this);
        this.qToggle = this.qToggle.bind(this);
        this.dToggle = this.dToggle.bind(this);
        this.vToggle = this.vToggle.bind(this);
        this.pToggle = this.pToggle.bind(this);
        this.sToggle = this.sToggle.bind(this);
        this.shareToFb = this.shareToFb.bind(this);
        this.showWebModal = this.showWebModal.bind(this);
        this.showQRModal = this.showQRModal.bind(this);
        this.downloadQRCode = this.downloadQRCode.bind(this);
        this.showPreviewModal = this.showPreviewModal.bind(this);
        this.handlePlaylist = this.handlePlaylist.bind(this);
        this.listenToScroll=this.listenToScroll.bind(this);
    }


    componentDidMount() {

        this.playlistDetail();
        this.playlistVignets();

        this.setState({plId: this.props.match.params.id});

        let data = { user_id : this.Auth.getProfile().user_id , size :50, type : 'list',  playlistId : this.props.match.params.id,offset : 0};
        this.props.allVignetsData(data);

        /*const container = document.querySelector('.modal-body');
        container.addEventListener('scroll', this.listenToScroll)*/
    }

    componentWillUnmount() {
       /* const container = document.querySelector('.modal-body');
        container.removeEventListener('scroll', this.listenToScroll)*/
    }

    listenToScroll = () => {
        const container = document.querySelector('.modal-body')
        let lastOffset = document.querySelector('.list-container').childElementCount;
        var scrollTop = container.scrollTop;
        var scrollHeight = container.scrollHeight;
        var offsetHeight = container.offsetHeight;
        var contentHeight = scrollHeight - offsetHeight;

        // console.log(scrollTop+"----"+scrollHeight+"----"+offsetHeight+"-----"+contentHeight);

        if (contentHeight <= scrollTop) {
            let plId = "";
            let data = { user_id : this.Auth.getProfile().user_id , size : 50, type : 'list',  playlistId : plId?plId:'', offset : lastOffset};
            this.props.moreVignetsData(data);
        }

    }
    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {


        if( this.props.playlistData.resetPlaylist === true && prevProps.playlistData.resetPlaylist !== this.props.playlistData.resetPlaylist) {
            this.setState({backtoPlaylist : true})
        }

        if(this.props.playlistData.playlistUpdated !== prevProps.playlistData.playlistUpdated ) {

            this.playlistVignets();
        }

        if(this.props.playlistData.detailSaved !== prevProps.playlistData.detailSaved ) {
            this.playlistDetail();
        }

        if(this.props.playlistData.newImage !== prevProps.playlistData.newImage ) {
            this.setState({image_path : this.props.playlistData.newImage});
        }

        console.log(this.props.playlistData.plDuplicated+"-----"+prevProps.playlistData.plDuplicated+"----------"+this.props.playlistData.playlistId+"----------"+prevProps.playlistData.playlistId);
        if(this.props.playlistData.plDuplicated !== prevProps.playlistData.plDuplicated && this.props.playlistData.playlistId !== prevProps.playlistData.playlistId) {
            this.setState({detUrl : "/playlist/"+this.props.playlistData.playlistId, showConfirmSimilar : false}, function() {
                window.location.href = this.state.detUrl;
            });



        }
        if(this.props.playlistData.vignetsList !== prevProps.playlistData.vignetsList ) {
           // this.setState({items :this.props.playlistData.vignetsList});
        }
        if(this.state.showVignetList !== prevState.showVignetList && this.state.showVignetList){
            const container = document.querySelector('.modal-body');
            container.addEventListener('scroll', this.listenToScroll)
        }
        if(this.state.showVignetList !== prevState.showVignetList && !this.state.showVignetList){
            const container = document.querySelector('.modal-body');
            container.removeEventListener('scroll', this.listenToScroll)
        }
    }

    playlistDetail(){
        let data = { 'plId' : this.props.match.params.id  };
        this.props.getPlaylist(data);
    }

    playlistVignets(){
        let data = { 'plId' : this.props.match.params.id  };
        this.props.getPlaylistVignets(data);
    }
    editPlaylist() {
        this.props.showPlaylistModal();
    }






    confirmDelete() {
        this.setState({showConfirmDelete : true})
        /*let data = {plId : this.props.playlistData.playlistId}
        this.props.deletePlaylist(data);*/
    }
    csToggle() {
        this.setState({showConfirmSimilar : !this.state.showConfirmSimilar});
    }

    dToggle() {
        this.setState({showConfirmDelete : !this.state.showConfirmDelete})
    }

    deletePlaylist() {
        let data = {plId : this.props.playlistData.playlistId}
        this.props.deletePlaylist(data);
    }

    createDuplicatePlaylist(){
        let data = {plId : this.props.playlistData.playlistId, user_id : this.Auth.getProfile().user_id}
        this.props.duplicatePlaylist(data);
    }

    confirmDuplicate() {
        this.setState({showConfirmSimilar : true})
        /*let data = {plId : this.props.playlistData.playlistId}
        this.props.deletePlaylist(data);*/
    }

    mToggle() {
        console.log(this.state.showPop);
        this.setState({
            showPop: !this.state.showPop
        });
    }

    cToggle() {
        this.setState({
            copyUrl: !this.state.copyUrl
        });
    }

    qToggle() {
        console.log(this.state.showQR);
        this.setState({
            showQR: !this.state.showQR
        });
    }
    sToggle() {
        console.log(this.state.showQR);
        this.setState({
            showshareModal: !this.state.showshareModal
        });
    }
    vToggle(){
       // alert(this.state.showVignetList)
        this.setState({
            showVignetList: !this.state.showVignetList,
        });
        this.props.clearVignets();
    }

    /*********** Copy the web url to share among users ********/
    showWebModal(vigID)
    {
        var uid= this.Auth.getProfile().user_id;

        var e = document.createElement("textarea");
        var url ="https://a.vignets.com/react-vignet/player/?"+vigID+'/'+uid ;
        e.value = String(url);
        document.body.appendChild(e);
        e.select();
        document.execCommand("copy");
        document.body.removeChild(e);

        this.setState({
            copyUrl : url
        });

    }

    shareToFb(type, vignet_id, vignet_title) {

        var baseUrl =String('https://agency.vignets.com/player//'+vignet_id);

        let rootUrl = '';let shareUrl ='';


        if(type === 'fb') {
            /******************* Fb Share**************/
            let rootUrl = baseUrl + "//fb";
            shareUrl = "https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(rootUrl);
        }
        else if(type === 'wa') {
            /******************* Whatsapp Share**************/
            rootUrl = baseUrl + "//wa";
            shareUrl = "https://api.whatsapp.com/send?text=" + rootUrl;
        }
        else if(type === 'em') {
            /******************* Email Share************/
            rootUrl = baseUrl + "//em";
            shareUrl = "mailto:?subject=" + vignet_title + "&body=" + rootUrl;
        }


       this.setState({
           shareUrl : shareUrl
       }, function() {
           window.open(shareUrl,'_blank',"toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=600,height=400");
       });
    }

    /*********** Scan QR code of vignet********/
    showQRModal(vigID)
    {
        this.setState({
            showQR : true
        });

    }

    downloadQRCode() {
        let vignet_id = this.state.vignet_id;
        var canvas = document.querySelector( 'canvas' );
        var link = document.createElement('a');
        link.innerHTML = 'Download';
        link.addEventListener('click', function(ev) {
            link.href = canvas.toDataURL();
            link.download = vignet_id+".png";
        }, false);
        document.body.appendChild(link);
        link.click();
    }


    getUploadedFile(fileName) {
        console.log(fileName);
        this.setState({
            image_path: fileName
        });
        //Request to purging
        this.props.getImagepurged({image_name : this.state.plId, image_path : fileName});

    }


    addToPlaylist() {
        console.log(this.props.playlistData);
        this.props.loadVignets();
        let data = {plid :  this.props.match.params.id , vigids : this.props.vignetsData.selected_ids}
        this.props.addItemToPlaylist(data);
        this.vToggle();

    }

    showPreviewModal(public_view,vignet_id,user_id ){
        let playerUrl = "";
        if(public_view === 1) {
            playerUrl = PUB_PLAYER_PATH+ vignet_id;
        }
        else{
            playerUrl = UNPUB_PLAYER_PATH+ vignet_id+'//';
        }
        this.setState({
            showPreview : true,
            playerUrl :playerUrl
        });
    }
    pToggle() {
        this.setState({showPreview : !this.state.showPreview})
    }

    handlePlaylist() {
        this.setState({showPlOptions : !this.state.showPlOptions})
    }

    render() {

        console.log(this.props.playlistData);
        console.log(this.state.shareUrl);
        if (this.state.backtoPlaylist) {
            return <Redirect exact to='/playlists'/>;
        }

        if (this.state.detUrl && this.props.match.url !== '/playlist/' + this.props.playlistData.playlistId) {
            return <Redirect exact to={this.state.detUrl}/>;
        }

        let playlist = this.props.playlistData ? this.props.playlistData.playListDetail : undefined;
        let vignetsList = this.props.playlistData ? this.props.playlistData.vignetsList : undefined;
        let vignets = (this.props.vignetsData.searchText || this.props.vignetsData.sort) ? this.props.vignetsData.filteredData :  this.props.vignetsData.vignetsList;
        let img_name = 'no-image';
        if (playlist) {
            img_name = playlist.pl_id;
        }

        console.log(playlist);

        let imgSrc = IMGIX_PATH + 'assets/slider/' + img_name + '.jpg?q=' + Math.random() + '&fit=crop&h=150&w=150&auto=enhance&dpr=3%203x';




            console.log(vignetsList);
        console.log(this.state.modal);

        return (

            <div className="list-wrap wrap-style ply-wrp">


                <div className="right-content-section">
                    <div className="bottom-title">
                        <div className=" side-menu-icon">
                            <button className="icon-lib-list menu-icon"
                                    onClick={() => this.handlePlaylist()}
                                    aria-controls="collapse-pl-options"
                                    aria-expanded={this.state.showPlOptions} ></button>

                            <Collapse in={this.state.showPlOptions}>
                                <ul id="collapse-pl-options" className="toggle-flip">
                                    <li>
                                        <a href="javascript:void(0);" className="icon-lib"
                                           onClick={() => this.editPlaylist()}>Edit Details</a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);" className="icon-lib"
                                           onClick={() => this.confirmDuplicate()}>Create Similar Playlist</a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);" className="last-row icon-lib"
                                           onClick={() => this.confirmDelete()}>Delete this Playlist</a>
                                    </li>
                                </ul>
                            </Collapse>

                        </div>
                        <div className="image-upload-block-playlist">
                            <div className="image-up-playlist">
                                {this.state.image_path !== null &&
                                <img src={this.state.image_path} crossOrigin="anonymous"
                                     className="text-center" alt="playlist"/>
                                }
                                {this.state.image_path === null &&
                                <img src={imgSrc} alt="default"/>
                                }

                                <UploadFile getUploadedFile={this.getUploadedFile.bind(this)} type="add" progress="progress-bar-wrapper1"
                                            item_type="PLAYLIST" unique_id = {(this.props.playlistData && this.props.playlistData.playListDetail && this.props.playlistData.playListDetail.pl_id) ? this.props.playlistData.playListDetail.pl_id : ''} />
                                {this.props.uploadData.loader === true &&
                                <div id="progress-bar-wrapper1"></div>
                                }
                                {this.props.uploadData.errors === true &&
                                <p className="error-message">{this.props.uploadData.errorMessage}</p>
                                }
                            </div>
                        </div>
                        {playlist &&
                        <div className="title-content">
                            <h2>{playlist.pl_name}</h2>
                            <p className="title-sub-content-left">{playlist.created_date}<span className="title-sub-content">{playlist.user_name}</span>
                            </p>
                            <p className="title-desc">{playlist.pl_desc}</p>
                            <div className="title-icons">

                                    <a href="javascript:void(0);" className="title-menu-icons">
                                        <span className="ico-add" onClick={() =>this.vToggle()}></span>
                                    </a>
                                {/*
                                    <a href={"#/playlist/add/" + this.props.playlistData.playlistId}
                                       className="title-menu-icons">
                                        <span className="ico-add"></span>
                                    </a>
                               */ }
                                <a href={"/view-playlist/"+playlist.pl_id} className="title-menu-icons" target="_blank">
                                    <span className="icon-lib-list ico-eye"></span>
                                </a>
                                {/*<a href="javascript:void(0);" className="title-menu-icons upload">
                                    <span className="icon-lib-list ico-upload"></span>
                                </a>*/}
                            </div>
                        </div>
                        }
                    </div>
                    <div className="content-table-sec">
                        <div className="vignet-table-block">
                            <table className="table vignet-table title-table">
                                <thead>
                                <tr>
                                    <th>VIGNETS</th>
                                    {/*<th>AUTHOR</th>
                                    <th>PLAYLIST</th>*/}
                                </tr>
                                </thead>
                                <tbody className="table-body-section">
                                {!vignetsList &&
                                <tr>
                                    <td colSpan="3">
                                        <div className="loaderWrapper">
                                            <Loader type="ThreeDots" color="#23ada6"  height="50" width="50"/></div>
                                    </td>
                                </tr>
                                }
                                {vignetsList && vignetsList.length === 0 && this.props.playlistData.loading === true &&
                                <tr>
                                    <td colSpan="3">
                                        <div className="loaderWrapper">
                                            <Loader type="ThreeDots" color="#23ada6"  height="50" width="50"/></div>
                                    </td>
                                </tr>
                                }



                                {vignetsList && vignetsList.length > 0 && vignetsList.map((item, index) =>

                                        <VigItem playlistItem={item} />


                                    )}
                                </tbody>
                            </table>

                            {vignetsList && vignetsList.length === 0 && this.props.playlistData.loading === false &&
                            <div className="new-page-content">
                                <div className="new-page-wrap">
                                    <h1>This playlist is currently empty</h1>
                                    <p>Start adding Vignets to this playlist</p>
                                    <div className="button-new-block">
                                    <a href="javascript:void(0);" onClick={() =>this.vToggle()}>
                                        <button className="vig-list-button">GO TO VIGNETS LIST</button>
                                    </a>
                                    </div>
                                </div>
                            </div>
                            }

                        </div>
                        <div className="table-header">
                            <p className="header-content-right">vignets : {vignetsList? vignetsList.length : '0'}</p>
                            <p className="header-content-right">Total duration : {vignetsList? vignetsList.length *2 : '0'} seconds</p>
                        </div>
                    </div>
                </div>
                <NewPlaylist/>

                <Modal isOpen={this.state.showConfirmDelete} id="delete-playlist">
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">
                            Are you sure to delete the playlist?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.dToggle}>Cancel</Button>
                        <Button color="primary" onClick={this.deletePlaylist}>Confirm</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.showConfirmSimilar} id="similar-playlist">
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">
                            Are you sure to create similar playlist?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.csToggle}>Cancel</Button>
                        <Button color="primary" onClick={this.createDuplicatePlaylist}>Confirm</Button>
                    </ModalFooter>
                </Modal>


                <Modal isOpen={this.state.showVignetList} toggle={() =>this.vToggle()} centered={true} className="vig-mod modal-lg vig-modal user-md create-new-pop full-wd-mod" id="vignetModal-user" tabindex="-1" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div className="modal-content-wrapper">
                            <div className="modal-header">
                                <form id="company">
                                    <button type="button" className="modal-btn-close"  data-dismiss="modal" aria-label="Close" onClick={(e) =>this.vToggle(e)} >✕</button>
                                    <h4 className="modal-title icon-lib title-icon">Add Vignets to Playlist</h4>
                                </form>
                            </div>
                            <ModalBody>
                                <FilterBar pageName="VIGNETS" />
                                <div className="list-wrap">
                                    <div className="list-container add-vig">
                                        {!vignets &&
                                        <div className="loaderWrapper">
                                            <Loader type="ThreeDots" color="#23ada6"  height="50" width="50"/>
                                        </div>
                                        }

                                        {vignets &&
                                        vignets.map((entry, index) => <VignetItem detail={entry} id={index} itemType="vignets" />)

                                        }
                                    </div>
                                    {this.props.vignetsData.selected_ids.length !== 0 &&
                                        <div className="pl-msg-wrap">
                                            <div className="pl-msg-l">
                                                <span className="pl-msg">Start adding Vignets to New Playlist</span>
                                                <span
                                                    className="pl-msg">Selected Vignets: {this.props.vignetsData ? this.props.vignetsData.selected_ids.length : 0}</span>
                                            </div>
                                            <div className="pl-msg-r">
                                                <button name="done_btn" className="btn" onClick={() => {this.addToPlaylist()}}>DONE</button>
                                            </div>
                                        </div>
                                    }
                                </div>

                            </ModalBody>
                        </div>
                </Modal>

            </div>

        );
    }
}

PlaylistDetailContainer.propTypes = {
    pageName : PropTypes.string
}

function mapStateToProps(state) {
    return {
        playlistData  :state.playlist.playlistData,
        uploadData : state.upload.uploadData,
        vignetsData  :state.vignets.vignetsData,
    };

}
export default  withRouter(connect(mapStateToProps, {
    getPlaylist : playlistActions.getPlayListDetails,
    getPlaylistVignets : playlistActions.showPlaylistVignets,
    showPlaylistModal : playlistActions.showPlaylistModal,
    deletePlaylist : playlistActions.deletePlaylist,
    duplicatePlaylist : playlistActions.duplicatePlaylist,
    getImagepurged : playlistActions.purgeImage,
    allVignetsData : vignetsActions.fetchVignetsData,
    addItemToPlaylist : playlistActions.addToPlaylist,
    selectVignets : vignetsActions.chooseVignets,
    clearVignets  : vignetsActions.clearVignets,
    loadVignets  : playlistActions.addToPlaylist,
    moreVignetsData : vignetsActions.fetchmoreVignetsData,
})(PlaylistDetailContainer));



// WEBPACK FOOTER //
// ./src/components/playlist/DetailContainer.js